module.exports = __webpack_public_path__ + "static/media/70.80338ab4.gif";